import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import AdminDashboard from './pages/admin-dashboard';
import LoginPage from './pages/login';
import TransactionHistory from './pages/transaction-history';
import RecipientsManagement from './pages/recipients-management';
import ProfileManagement from './pages/profile-management';
import Dashboard from './pages/dashboard';
import TransactionReview from './pages/transaction-review';
import DocumentUpload from './pages/document-upload';
import SendMoneyFlow from './pages/send-money-flow';
import Register from './pages/register';
import AgentRegistration from './pages/agent-registration';
import AgentDashboard from './pages/agent-dashboard';
import CommissionManagement from './pages/commission-management';
import AuditTrail from './pages/admin/audit-trail';
import UserManagement from './pages/admin/user-management';
import AccountLimits from './pages/admin/account-limits';
import RegulatoryReports from './pages/admin/regulatory-reports';
import SystemAlerts from './pages/admin/system-alerts';
import AgentPerformanceAnalytics from './pages/agent-performance-analytics';
import SecurityPlatformHealthMonitor from './pages/security-platform-health-monitor';
import RegulatoryReportingCenter from './pages/regulatory-reporting-center';

export default function AppRoutes() {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          {/* Define your route here */}
          <Route path="/" element={<LoginPage />} />
          <Route path="/admin-dashboard" element={<AdminDashboard />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/transaction-history" element={<TransactionHistory />} />
          <Route path="/recipients-management" element={<RecipientsManagement />} />
          <Route path="/profile-management" element={<ProfileManagement />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/transaction-review" element={<TransactionReview />} />
          <Route path="/document-upload" element={<DocumentUpload />} />
          <Route path="/send-money-flow" element={<SendMoneyFlow />} />
          <Route path="/register" element={<Register />} />
          <Route path="/agent-registration" element={<AgentRegistration />} />
          <Route path="/agent-dashboard" element={<AgentDashboard />} />
          <Route path="/commission-management" element={<CommissionManagement />} />
          <Route path="/admin/audit-trail" element={<AuditTrail />} />
          <Route path="/admin/user-management" element={<UserManagement />} />
          <Route path="/admin/account-limits" element={<AccountLimits />} />
          <Route path="/admin/regulatory-reports" element={<RegulatoryReports />} />
          <Route path="/admin/system-alerts" element={<SystemAlerts />} />
          <Route path="/agent-performance-analytics" element={<AgentPerformanceAnalytics />} />
          <Route path="/security-platform-health-monitor" element={<SecurityPlatformHealthMonitor />} />
          <Route path="/regulatory-reporting-center" element={<RegulatoryReportingCenter />} />
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
}